// custom-add-to-cart.js (paste/overwrite)
(function(){
  document.addEventListener('DOMContentLoaded', function(){

    // selector from your pasted HTML
    const BUTTON_SELECTOR = '.enj-add-to-cart-btn';

    // try common app drawer openers
    function tryOpenDrawer(){
      try {
        if (window.AOV && typeof window.AOV.openDrawer === 'function') return window.AOV.openDrawer();
        if (window.Amp && typeof window.Amp.openDrawer === 'function') return window.Amp.openDrawer();
        if (window.AMP && typeof window.AMP.openDrawer === 'function') return window.AMP.openDrawer();
        if (window.SLIDE_CART && typeof window.SLIDE_CART.open === 'function') return window.SLIDE_CART.open();
        // fallback: click any known drawer toggle/button if present
        const fb = document.querySelector('[data-open-cart], .open-cart, .cart-toggle, .cart-icon, .aov-cart-button');
        if (fb) { fb.click(); return; }
      } catch(e){ console.warn('tryOpenDrawer error', e); }
    }

    async function addToCartByForm(form, btn){
      if(!form) return;
      // prevent double submissions
      if(btn && btn.disabled) return;
      if(btn){ btn.disabled = true; btn.setAttribute('aria-disabled','true'); }
      const original = btn ? btn.innerHTML : null;
      if(btn) btn.innerHTML = 'Adding...';

      const data = new FormData(form);
      // ensure variant id present (best-effort)
      if(!data.has('id')){
        const vid = form.querySelector('input[name="id"], input[name="variant_id"], [data-variant-id]')?.value ||
                    form.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
        if(vid) data.set('id', vid);
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        });
        const json = await res.json();
        console.info('Added to cart (AJAX):', json);

        // open app drawer
        tryOpenDrawer();

        // update cart count
        fetch('/cart.js').then(r=>r.json()).then(cart=>{
          const counter = document.querySelector('.cart-count, #CartCount, .enjk-cartcount');
          if(counter) counter.textContent = cart.item_count;
        }).catch(()=>{});
      } catch(err){
        console.error('AJAX add failed:', err);
        // fallback: if you want to redirect to /cart on failure, uncomment next line
        // window.location.href = '/cart';
      } finally {
        if(btn){ btn.disabled = false; btn.setAttribute('aria-disabled','false'); btn.innerHTML = original; }
      }
    }

    // Attach capture listener directly to the buttons (stronger than generic submit)
    function bindButtons(){
      const buttons = document.querySelectorAll(BUTTON_SELECTOR);
      buttons.forEach(btn => {
        // avoid duplicate binding
        if(btn.__customBound) return;
        btn.__customBound = true;

        // use capture so we block other handlers early
        btn.addEventListener('click', function(e){
          try {
            // block native/default actions & other handlers
            e.preventDefault();
            e.stopImmediatePropagation();
          } catch(err){}

          // find the closest form; most product buttons sit inside a product form
          const form = btn.closest('form') || document.querySelector('form[action^="/cart/add"]');
          if(!form){
            // if no form, maybe a direct add link — let the fallback run
            console.warn('Add-to-cart: no form found for button', btn);
            return;
          }

          // call our ajax add handler
          addToCartByForm(form, btn);
        }, true); // capture true
      });
    }

    // initial bind + re-bind on DOM changes (for variants, quick view etc)
    bindButtons();
    const mo = new MutationObserver(function(muts){
      muts.forEach(m => {
        m.addedNodes.forEach(node => {
          if(node.nodeType !== 1) return;
          // if new buttons inserted, try bind again
          if(node.querySelector && node.querySelector(BUTTON_SELECTOR)) bindButtons();
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    console.log('custom-add-to-cart (button-targeted) initialized for', BUTTON_SELECTOR);
  });
})();
